import { useCallback, useMemo } from 'react';

import { useJobsNwtTracking } from '@xing-com/crate-jobs-tracking';

const getJobTrackingCodeFromUrl = (url?: string): string => {
  if (!url) return '';

  const trackingParam = new URLSearchParams(
    url.substring(url.indexOf('?'))
  ).get('ijt');

  return trackingParam ?? '';
};

type ClickCallback = React.MouseEventHandler<HTMLElement>;

type HookProps = {
  isExternalJob: boolean;
  jobId: string;
  url?: string;
  clickCallback?: ClickCallback;
};

export const useJobTeaserClickExternalTracking = ({
  isExternalJob,
  jobId,
  url,
  clickCallback,
}: HookProps): ClickCallback | undefined => {
  const trackNwt = useJobsNwtTracking();
  const jobTrackingCode = useMemo(() => getJobTrackingCodeFromUrl(url), [url]);

  const clickWithExternalTracking = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      trackNwt({
        eventSchema: 'basic',
        event: 'viewed_screen',
        page: 'jobs/detail_external',
        context: 'auto_redirect',
        itemUrn: `surn:x-xing:jobs:posting:${jobId}`,
        entryPoint: `jobs_origin_${jobTrackingCode}`,
      });
      trackNwt({
        eventSchema: 'basic',
        event: 'job_detail_viewed',
        page: 'jobs/detail_external',
        context: 'auto_redirect',
        itemUrn: `surn:x-xing:jobs:posting:${jobId}`,
        entryPoint: `jobs_origin_${jobTrackingCode}`,
      });

      if (clickCallback) {
        clickCallback(e);
      }
    },
    [clickCallback, jobId, jobTrackingCode, trackNwt]
  );

  return isExternalJob ? clickWithExternalTracking : clickCallback;
};
